import { render, staticRenderFns } from "./GhanaFlag.vue?vue&type=template&id=60f4cf16"
import script from "./GhanaFlag.vue?vue&type=script&lang=js"
export * from "./GhanaFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports